import {Modal} from 'bootstrap';
import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-entity-select-modal',
  templateUrl: './entity-select-modal.component.html',
  styleUrls: ['./entity-select-modal.component.css'],
  standalone: false
})
export class EntitySelectModalComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;
  constructor() { }

  ngOnInit() {
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
